import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { cartonCacheService } from '../services/cartonCacheService';
import { apiService } from '../services/api';
import { ProjectCarton } from '../types';

const CartonDetailPage: React.FC = () => {
  const { cartonId } = useParams<{ cartonId: string }>();
  const [carton, setCarton] = useState<ProjectCarton | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchCarton = async () => {
      setLoading(true);
      setError(null);
      // Try cache first
      let cached = undefined;
      if (cartonId) {
        cached = await cartonCacheService.getCartonDetails(cartonId);
        if (cached) setCarton(cached);
      }
      // Try API for fresh data
      try {
        if (cartonId) {
          const apiCarton = await apiService.getCarton(cartonId);
          setCarton(apiCarton);
          await cartonCacheService.cacheCartonDetails(apiCarton);
        }
      } catch (err) {
        if (!cached) setError('Failed to fetch carton details from API and no cached data available.');
      } finally {
        setLoading(false);
      }
    };
    fetchCarton();
  }, [cartonId]);

  if (loading) {
    return <div style={{ padding: '2rem', textAlign: 'center' }}>Loading carton details...</div>;
  }
  if (error) {
    return <div style={{ padding: '2rem', textAlign: 'center', color: 'red' }}>{error}</div>;
  }
  if (!carton) {
    return <div style={{ padding: '2rem', textAlign: 'center' }}>No carton details found.</div>;
  }

  return (
    <div style={{ padding: '2rem', textAlign: 'center' }}>
      <h1>Carton Details</h1>
      <p><strong>Code:</strong> {carton.code}</p>
      <p><strong>Status:</strong> {carton.status}</p>
      <p><strong>Received:</strong> {carton.is_received ? 'Yes' : 'No'}</p>
      {/* Add more carton details as needed */}
    </div>
  );
};

export default CartonDetailPage; 